export const CoreInitiativesFilesName = 'CoreInitiativesFiles';
